import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Alert, InputGroup } from "react-bootstrap";
import { supabase } from "../supabase";
import { toast, ToastContainer } from "react-toastify";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import GoToTop from "../GoToTop";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    setError("");

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      toast.error(error.message);
    } else {
      setLoading(false);
      toast.success("Logged in successfully");

      navigate("/dashboard");
    }
  };
  return (
    <>
    <GoToTop/>
      <div className="loginPage">
        <div class="logincontainer">
          <h1>LOGIN</h1>
          <form onSubmit={handleSubmit}>
            <label>Email</label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              class="form-control mb-2"
              required
            />

            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              class="form-control mb-3"
              required
            />

            <button
              type="submit"
              disabled={loading ? true : false}
              class="btn btn-danger w-100"
            >
              {loading ? <>Loading. Please wait...</> : <>AUTHENTICATE</>}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
